import { css } from 'styled-components';
import colors from '../../style/colors';
import { actionColor, actionLight } from '../../style/theme-helpers';

type PillSize = {
  height: string;
  padding?: string;
};

export const sizes = {
  auto: {
    height: 'auto',
    padding: 'auto',
  },
  xs: {
    height: '24px',
    padding: '1px 12px 1px 12px',
  },
  sm: {
    height: '32px',
    padding: '5px 16px 5px 16px',
  },
} satisfies Record<string, PillSize>;

export const variants = {
  gray: css`
    background-color: ${colors.white};
    border-color: ${colors.gray300};
    color: ${colors.gray800};
    &.active {
      color: ${actionColor};
      border-color: ${actionColor};
      background-color: ${actionLight};
    }
    &:active,
    &:active:not(.disabled):not([disabled]) {
      background-color: ${actionLight};
    }
    &:hover {
      border-color: ${actionColor};
      color: ${actionColor};
    }
    &[disabled]:hover,
    &[disabled] {
      cursor: not-allowed;
      background-color: ${colors.gray50};
      border-color: ${colors.gray300};
      color: ${colors.gray600};
      & i {
        color: ${colors.gray600};
      }
    }
    &:focus-visible {
      box-shadow: 0 0 0 3px ${colors.sky};
    }
    &.is-loading,
    &.is-loading:hover {
      border-color: ${colors.transparent};
    }
  `,
  action: css`
    background-color: ${colors.gray100};
    border-color: ${colors.gray100};
    color: ${colors.gray800};
    &.active {
      background-color: ${props => props.theme.actionLight};
      border-color: ${props => props.theme.actionColorDark};
      color: ${props => props.theme.actionColor};
    }
    &:active,
    &:active:not(.disabled):not([disabled]) {
      background-color: ${props => props.theme.actionColorDark};
      border-color: ${props => props.theme.actionColor};
      color: ${colors.white};
    }
    &:hover {
      background-color: ${props => props.theme.actionColor};
      border-color: ${props => props.theme.actionColor};
      &:not(.active) {
        color: ${colors.white};
        & i {
          color: ${colors.white};
        }
      }
      &.active {
        background-color: ${props => props.theme.actionLight};
      }
    }
    &[disabled]:hover,
    &[disabled] {
      cursor: not-allowed;
      background-color: ${colors.gray100};
      border-color: ${colors.gray600};
      color: ${colors.gray600};
      & i {
        color: ${colors.gray600};
      }
    }
    &:focus-visible {
      box-shadow: 0 0 0 3px ${colors.sky};
    }
    &.is-loading,
    &.is-loading:hover {
      border-color: ${colors.transparent};
    }
  `,
};
